import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { SeguridadDocenteModel } from '../model/seguridad.docente.model';
import { StorageService } from '../services/storage.service';
import { AuthenticationService } from '../services/authentication.service';
import { AppSettings } from '../services/app-settings';

@Injectable()
export class UserService {

  constructor(
    private auth: AuthenticationService,
    private storage: StorageService
  ) {

  }

  getData(): any | null {
    if (!this.auth.isAuthenticated())
      return null;

    let value = this.storage.get(AppSettings.STORAGE_NAME);
    if (value == null || JSON.parse(value).DATA.length == 0)
      return null;

    return JSON.parse(value);
  }

  getDocente(): SeguridadDocenteModel {
    let data = this.getData();

    let res: SeguridadDocenteModel = new SeguridadDocenteModel(
      data.DATA[0].DOCENTE
      , data.DATA[0].NOMBRES
      , data.DATA[0].TIPO_DOCUMENTO
      , data.DATA[0].NRO_DOCUMENTO
      , data.DATA[0].EMAIL
      , data.DATA[0].ES_DOCENTE
      , data.DATA[0].ES_TUTOR
    );
    return res;
  }

  getUserLogin(): string {
    let data = this.getData();

    return data.LOGIN;
  }

  confiEditor(): any {

    let config: any = {
      height: 250,
      theme: 'silver',
      // powerpaste advcode toc tinymcespellchecker a11ychecker mediaembed linkchecker help
      plugins: 'print preview fullpage searchreplace code autolink directionality visualblocks visualchars fullscreen image imagetools link media template codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
      toolbar: 'formatselect | bold italic strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | link image',
      image_advtab: true,
      imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions',
      templates: [
        { title: 'Test template 1', content: 'Test 1' },
        { title: 'Test template 2', content: 'Test 2' }
      ],
      language: 'es'

    };
    return config;
  }
}



// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/support/services/user.service.ts